import {combineReducers} from 'redux';
import {roomMap, roomMapHasErrored, roomMapIsLoading } from './roomMapReducer';
import {personMap} from './personMapReducer';
import {outlookItem} from './outlookItemReducer';

import {userRegTokens, userRegLicense} from './userRegReducer';

const rootReducer = combineReducers({
  roomMap,
  roomMapHasErrored,
  roomMapIsLoading,

  personMap,

  outlookItem,

  userRegTokens,
  userRegLicense
});

export default rootReducer;